import { render } from "./TriggerReviewQueue.vue?vue&type=template&id=b7adf176&scoped=true"
import script from "./TriggerReviewQueue.vue?vue&type=script&lang=js"
export * from "./TriggerReviewQueue.vue?vue&type=script&lang=js"

import "./TriggerReviewQueue.vue?vue&type=style&index=0&id=b7adf176&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7adf176"]])

export default __exports__